export enum NotificationRecipientType {
    Email,
    Sms
}
